import {
  addPartnerButtonPages,
  downloadOfferPages,
  getNextButtonText,
  noNextButtonIconPages
} from 'utils/actions';
import { useWizardNavigation } from 'hooks/useWizardNavigation';
import { AddPartnerButton } from 'components/Wizard/AddPartnerButton';
import { BackButton, ContinueButton } from 'components/Wizard';
import { ValidationError } from 'components/ValidationError';
import { DownloadButton } from 'components/DownloadButton';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const NavigationSection = ({ onPersonSwitch }: { onPersonSwitch?: () => void }) => {
  const { currentScreen } = useWizardNavigation();
  const { t } = useTranslation('wizardPrivateHealthInsurance');

  return (
    <div className="flex flex-col s:flex-row s:justify-between items-center bg-white-100 px-m s:px-[80px] py-l s:py-m  s:space-y-0">
      <div className="flex flex-col s:flex-row items-center gap-[8px] basis-1/2 py-s">
        {addPartnerButtonPages.includes(currentScreen) && (
          <AddPartnerButton onPersonSwitch={onPersonSwitch} />
        )}
        {!addPartnerButtonPages.includes(currentScreen) && <BackButton />}
        <Button
          variant="outlined"
          size="large"
          className="hidden s:block"
          aria-label={t('actions.jumpToSidebar')}
          onClick={() => {
            const sidebar = document.getElementById('sidebar');

            sidebar?.focus();
          }}
          sx={{ width: 'fit-content' }}
        >
          {t('actions.jumpToSidebar')}
        </Button>
        <Button
          variant="outlined"
          size="large"
          className="block s:hidden"
          aria-label={t('actions.jumpToSidebar')}
          onClick={() => {
            const sidebar = document.getElementById('sidebar-mobile-price');

            sidebar?.focus();
          }}
          sx={{ width: 'fit-content' }}
        >
          {t('actions.jumpToSidebar')}
        </Button>
        {downloadOfferPages.includes(currentScreen) && (
          <DownloadButton currentPage={currentScreen} />
        )}
      </div>
      <div className="flex flex-nowrap content-center flex-col s:flex-row items-center s:justify-end w-full s:w-1/2 s:space-x-[16px] space-y-2 s:space-y-0">
        <ValidationError />
        <ContinueButton
          className="w-fit"
          title={getNextButtonText(currentScreen)}
          isIcon={!noNextButtonIconPages.includes(currentScreen)}
        />
      </div>
    </div>
  );
};
